// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import NotEnoughLink from 'app/components/Tariff/NotEnoughLink';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';
import PlainCheckbox from 'app/common/ui-next/plain-checkbox';

import SMSBundles from './SMSBundles';
import type { TariffType, Sub } from '../Tariff';
import Confirmation from '../Confirmation';
import enhanceConf from '../Confirmation/confirmationState';
import styles from './InformsExtended.scss';


type Props = {
  studentId: number,
  sub: Sub,
  subId: number,
  tariff: TariffType,
  subId: string,
  footnotes: Object,
  onInformerChange: (e: SyntheticEvent<HTMLElement>) => void,
  locked: boolean,
  smsBundlesEnabled: boolean,
  handlePayToday: (e: SyntheticEvent<HTMLElement>) => void,
  informersMod: Object,
  paying: boolean,
};

const InformsExtended = ({
  studentId,
  sub,
  subId,
  tariff,
  footnotes,
  onInformerChange,
  locked,
  smsBundlesEnabled,
  handlePayToday,
  informersMod,
  paying,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div className={styles.root}>
      <div>
        <div className={styles.title}>
          {/* Доступные способы информирования */}
          {`${t('informs_title')}:`}
        </div>

        {tariff.lk_provided
          && <PlainCheckbox
            name="lk"
            value="lk"
            onChange={onInformerChange}
            checked={informersMod.lk_enabled}
            className={styles.checkbox}
            label={
              <span className={styles.label}>
                <span>
                  {t('informer_lk')}
                  {footnotes.writeoff && <sup className={styles.fn}>{footnotes.writeoff.index}</sup>}
                </span>
                {/* <span className={styles.cost}>{tariff.lk_cost}</span> */}
                <PriceDiscounted
                  className={styles.cost}
                  studentId={studentId}
                  tariffId={!tariff.inside ? tariff.id : undefined}
                  tariffBundleId={tariff.inside ? tariff.id : undefined}
                  priceType={priceTypes.price_lk}
                />

              </span>
            }
            disabled={locked}
          />}

        {sub
          && tariff.lk_provided
          && tariff.lk_enabled
          && sub.lk_paid === false
          && !sub.is_paused
          && <Confirmation
            name="lk"
            onSubmit={handlePayToday}
            comment={
              <span>
                {t('inform_subscribe_confirm')}
                {footnotes.paytoday && <sup className={styles.fn}>{footnotes.paytoday.index}</sup>}
              </span>
            }
          >
            {handle => (
              !paying
                ? <div className={styles.warn}>
                  <NotEnoughLink handlePay={handle} />
                  {footnotes.paytoday && <sup className={styles.fn}>{footnotes.paytoday.index}</sup>}
                </div>
                : <div className={styles.paying}>{t('paying')}</div>
            )}
          </Confirmation>}
        {tariff.mobile_provided
          && <PlainCheckbox
            name="mobile"
            value="mobile"
            onChange={onInformerChange}
            checked={informersMod.mobile_enabled}
            className={styles.checkbox}
            label={
              <span className={styles.label}>
                <span>
                  {t('informer_mobile')}
                  {footnotes.writeoff && <sup className={styles.fn}>{footnotes.writeoff.index}</sup>}
                </span>
                {/* <span className={styles.cost}>{tariff.mobile_cost}</span> */}
                <PriceDiscounted
                  className={styles.cost}
                  studentId={studentId}
                  tariffId={!tariff.inside ? tariff.id : undefined}
                  tariffBundleId={tariff.inside ? tariff.id : undefined}
                  priceType={priceTypes.price_mobile}
                />
              </span>
            }
            disabled={locked}
          />}

        {sub
          && tariff.mobile_provided
          && tariff.mobile_enabled
          && sub.mobile_paid === false
          && !sub.is_paused
          && <Confirmation
            name="mobile"
            onSubmit={handlePayToday}
            comment={
              <span>
                {t('inform_subscribe_confirm')}
                {footnotes.paytoday && <sup className={styles.fn}>{footnotes.paytoday.index}</sup>}
              </span>
            }
          >
            {handle =>
              <div className={styles.warn}>
                <NotEnoughLink handlePay={handle} />
                {footnotes.paytoday && <sup className={styles.fn}>{footnotes.paytoday.index}</sup>}
              </div>
            }
          </Confirmation>}

        {tariff.email_provided
          && <PlainCheckbox
            name="email"
            value="email"
            onChange={onInformerChange}
            checked={informersMod.email_enabled}
            className={styles.checkbox}
            label={
              <span className={styles.label}>
                <span>{t('informer_email')}</span>
                {/* <span className={styles.cost}>{tariff.email_cost}</span> */}
                <PriceDiscounted
                  className={styles.cost}
                  studentId={studentId}
                  tariffId={!tariff.inside ? tariff.id : undefined}
                  tariffBundleId={tariff.inside ? tariff.id : undefined}
                  priceType={priceTypes.price_email}
                />

              </span>
            }
            disabled={locked}
          />}

        {tariff.sms_provided
            && <PlainCheckbox
              name="sms"
              value="sms"
              onChange={onInformerChange}
              checked={informersMod.sms_enabled}
              className={styles.checkbox}
              label={
                <span className={styles.label}>
                  <span>
                    {t('informer_sms')}
                    {footnotes.smspack && <sup className={styles.fn}>{footnotes.smspack.index}</sup>}
                  </span>
                  {/* <span className={styles.cost}>{tariff.sms_cost}</span> */}
                  <PriceDiscounted
                    className={styles.cost}
                    studentId={studentId}
                    tariffId={!tariff.inside ? tariff.id : undefined}
                    tariffBundleId={tariff.inside ? tariff.id : undefined}
                    priceType={priceTypes.price_sms}
                  />
                </span>
              }
              disabled={locked}
            />}
      </div>

      {sub && tariff.sms_provided && tariff.sms_enabled
        ? <SMSBundles
          sub={sub}
          subId={subId}
          footnotes={footnotes}
          tariff={tariff}
          smsBundlesEnabled={smsBundlesEnabled}
        />
        : <div className={styles.nosms}>
          <div>{t('informer_sms_disabled_comment')}</div>
        </div>
      }
    </div>
  );
};

export default enhanceConf(InformsExtended);
